import React from "react";
import SimpleBanner from "../Common/SimpleBanner";
import AboutUs_banner from "../../Assets/About/banaraimg.png";
import WorkWithUs from "../../Components/Careers/WorkWithUs";
import SubscribeTo from "../../Components/home/SubscribeTo";

const Careers = () => {
  return (
    <div className="overflow-x-hidden tracking-wide">
      <SimpleBanner
        image={AboutUs_banner}
        name="Careers"
        path="Home / Careers"
      />
      <WorkWithUs />
      <SubscribeTo />
    </div>
  );
};

export default Careers;
